import createRive from '../utilities/createRive';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const STATE_MACHINES_NAME = 'ep240k';

const setup = () => {
  const triggers = document.querySelectorAll('[data-w-column]');

  triggers.forEach((trigger) => {
    const canvas = trigger.querySelector('canvas');
    if (!canvas) return;

    const container = trigger.querySelector('[data-w-rive-parent]');
    // const identifier = canvas.getAttribute('data-w-identifier') ?? false;

    const riveArgs = {};
    // if (identifier === 'soundwave') {
    //   riveArgs.callback = (r) => {
    //     const values = r.stateMachineInputs(STATE_MACHINES_NAME);

    //     gsap.to(container, {
    //       scrollTrigger: {
    //         trigger: container,
    //         start: 'center center',
    //         end: () => `+=${window.innerHeight * 0.1}`,
    //         onUpdate: (self) => {
    //           if (values && values[0]) {
    //             const volume = values[0];
    //             volume.value = (1 - self.progress) * 100;
    //           }

    //           container.style.setProperty('--_value', 1 - self.progress);
    //         },
    //       },
    //     });
    //   };
    // }

    const rive = createRive(canvas, container, STATE_MACHINES_NAME, riveArgs);
    if (!rive) return;

    gsap.to(trigger, {
      scrollTrigger: {
        trigger: trigger,
        start: 'top bottom',
        end: 'bottom top',
        // fastScrollEnd: true,
        onEnter: () => {
          rive.r.startRendering();
          // rive.r.play(STATE_MACHINES_NAME, true);
        },
        onEnterBack: () => {
          rive.r.startRendering();
          // rive.r.play(STATE_MACHINES_NAME, true);
        },
        onLeaveBack: () => {
          // rive.r.pause(STATE_MACHINES_NAME);
          rive.r.stopRendering();
        },
        onLeave: () => {
          // rive.r.pause(STATE_MACHINES_NAME);
          rive.r.stopRendering();
        },
      },
    });
  });
};

export default function Rive() {
  return {
    init: () => {
      setup();
    },
  };
}
